<div #header class = "header">
    <ng-content select = "[card-header]"></ng-content>
</div>
<div #content class = "content">
    <ng-content select = "[card-content]"></ng-content>
</div>